<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.addBankAccount')"
        :rules="rules"
        :submit="submit"
        no-reset
        @close="close">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-select-currency-unit
                v-model="formData.currency"
                required
                prop="accountUseCurrency"
                name="accountUseCurrency" />
            <hts-form-select
                v-model="formData.bank"
                :items="listBankAccounts()"
                :label="$t('labels.bank')"
                required
                key-id="key"
                key-label="name"
                :filterable="true"
                :clearable="true"
                prop="bank"
                name="bank" />
            <hts-form-input
                v-model="formData.bankAccountNumber"
                :label="$t('labels.bankAccountNumber')"
                required
                prop="bankAccountNumber"
                name="bankAccountNumber" />
            <hts-form-input
                v-model="formData.bankBranch"
                :label="$t('labels.bankBranch')"
                required
                prop="bankBranch"
                name="bankBranch" />
            <hts-form-input
                v-model="formData.beneficiary"
                :label="$t('labels.beneficiary')"
                required
                prop="beneficiary"
                name="beneficiary" />
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import bank from '../ignore/bank'
const { listBankAccounts } = bank()

const cooperatorId = ref('')
const visible = ref(false)

const emits = defineEmits(['update:show', 'close', 'refreshTables'])

const rules = {
  accountUseCurrency: 'required',
  bank: 'required',
  bankAccountNumber: 'required',
  bankBranch: 'required',
  beneficiary: 'required'
}

const formData = reactive({
  currency: '',
  bank: '',
  bankAccountNumber: '',
  bankBranch: '',
  beneficiary: ''
})

const resetForm = () => {
  Object.assign(formData, {
    currency: 'VND',
    bank: '',
    bankAccountNumber: '',
    bankBranch: '',
    beneficiary: ''
  })
}

const open = async (id: string) => {
  formData.currency = 'VND'
  cooperatorId.value = id
  await updateBeneficiary(id)
  visible.value = true
}

const close = () => {
  visible.value = false
}

const submit = async () => {
  const api = $url.partner.bank.create
  const data: any = await $api(api, { uriParams: { cooperatorId: cooperatorId.value }, body: formData })
  const resData = data?.data?.value
  if (resData?.success) {
    resetForm()
    process.client && $toast().success($t('labels.createBankAccountSuccess'))
    close()
    emits('refreshTables')
  }
}

const updateBeneficiary = async (cooperatorId: string) => {
  const api = $url.partner['get-detail']
  const data = await $api(api, { uriParams: { ID: cooperatorId } })
  const resData: any = data?.data?.value
  if (resData?.success) {
    formData.beneficiary = resData.data.name
  }
}

defineExpose({
  open
})
</script>
